import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import useConnectedWallet from "../../hooks/useConnectedWallet";
import DropDown from "./DropDown";
import OutsideClickHandler from "react-outside-click-handler";

const PAGE_TITLES = [
  { path: "/overview", title: "Dashboard" },
  { path: "/vip-tiers", title: "VIP Tiers" },
  { path: "/transactions", title: "Swap History" },
  { path: "/balances", title: "Balances" },
  { path: "/api-reference", title: "API" },
  { path: "/widget", title: "Widget" },
  { path: "/referral", title: "Referral" },
  { path: "/whitelisted-ips", title: "Whitelisted IPs" },
  { path: "/whitelisted-websites", title: "Whitelisted Websites" },
  { path: "/webhooks", title: "Webhooks" },
  { path: "/sub-partner-fees", title: "Sub-Partner Fees" },
  { path: "/account", title: "Account" },
  { path: "/linked-wallets", title: "Linked Wallets" },
  { path: "/edit-wallet", title: "Withdraw Wallet" },
  { path: "/security", title: "Security" },
];

const TopBar = ({ handleToggleSidebar }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const user = useSelector((state) => state.userReducer.user);
  const navigate = useNavigate();
  const { address, isConnected } = useConnectedWallet();

  const toggleIsOpen = () => {
    setIsOpen(!isOpen);
  };

  const pageTitle =
    PAGE_TITLES.find((p) => location.pathname === p.path)?.title || "Dashboard";

  if (!user || Object.keys(user).length === 0) return null;

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className="isw-top">
        <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
          <button
            type="button"
            className="isw-burger"
            onClick={handleToggleSidebar}
            aria-label="Toggle menu"
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
          <div className="isw-top-title">{pageTitle}</div>
        </div>

        <div className="isw-top-r">
          {isConnected && address && (
            <button type="button" className="isw-chip isw-chip-wallet" onClick={() => navigate("/linked-wallets")}>
              <span className="dot" />
              <span className="ad">
                {address.slice(0, 6)}…{address.slice(-4)}
              </span>
              <span className="caret">▾</span>
            </button>
          )}
          <DropDown
            isOpen={isOpen}
            toggleIsOpen={toggleIsOpen}
            handleToggleSidebar={handleToggleSidebar}
            userIcon={user.response.partnerImage}
          />
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default TopBar;
